import React, { useEffect, useState } from "react";
import Waves from "react-wavify";
import "./cards.css";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";
import { useStateContext } from "../../../context/ContextProvider";

function ChargebackRatio() {
  const [success, setSuccess] = useState("");
  const { dropdownMerchant } = useStateContext();
  const successRate = async () => {
    try {
      const auth = sessionStorage.getItem("user");
      let formData = new FormData();
      formData.append("id", dropdownMerchant)

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result = await axios.post(
        `${baseUrl}/chargeback_Ratio`,
        formData,
        config
      );
      console.log(result)
      setSuccess(result.data.data);
      // setLoading(false)
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    successRate();
  }, [dropdownMerchant]);
  return (
    <>
      <div className="liquedblock">
        <Waves
          fill="#f44336"
          paused={false}
          options={{
            amplitude: 10,
            speed: 0.5,
            points: 3,
          }}
          style={{
            position: "absolute",
            height: `${success}%`,
            top: `${100 - success}%`,
            width: "100%",
          }}
        />
      </div>
      <div className="text-center">
        <h6>
          {success}% <br />
          CBR Rate
        </h6>
      </div>
    </>
  );
}

export default ChargebackRatio;
